import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useHRCopy from "../hr/i18n/useHRCopy";

export default function Giris() {
  const t = useHRCopy().login;
  const [form, setForm] = useState({ username: "", password: "", remember: false });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_LOGIN}/login`,
        {
          username: form.username,
          password: form.password
        },
        {
          withCredentials: true
        }
      );

      const { token } = response.data;
      localStorage.setItem("authToken", token);
      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      setError(t.failed);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="font-hanken bg-paper min-h-[calc(100vh-5rem)] flex flex-col">
      <main className="flex-1 flex items-center justify-center px-3 py-16">
        <div className="w-full max-w-5xl bg-white rounded-sm overflow-hidden border border-line grid grid-cols-1 md:grid-cols-2">
          <div className="relative hidden md:flex items-center justify-center bg-platinum">
            <img
              src="/images/onhuman.png"
              alt="OnHuman"
              className="w-72 h-72 object-contain"
            />
          </div>

          <div className="p-8 sm:p-12">
            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <div className="text-red-500 text-sm mb-2 font-medium">{error}</div>
              )}

              {/* Username */}
              <div>
                <label htmlFor="login-username" className="block text-sm font-medium text-steel mb-2">
                  {t.username}
                </label>
                <input
                  id="login-username"
                  type="text"
                  name="username"
                  value={form.username}
                  onChange={handleChange}
                  placeholder={t.usernamePh}
                  className="w-full px-4 py-3 rounded-sm border border-line focus:ring-2 focus:ring-royal/40 focus:border-royal outline-none text-ink"
                />
              </div>

              {/* Password */}
              <div>
                <label htmlFor="login-password" className="block text-sm font-medium text-steel mb-2">
                  {t.password}
                </label>
                <input
                  id="login-password"
                  type="password"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  className="w-full px-4 py-3 rounded-sm border border-line focus:ring-2 focus:ring-royal/40 focus:border-royal outline-none text-ink"
                />
              </div>

              {/* Remember */}
              <div className="flex items-center justify-between text-sm">
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    name="remember"
                    checked={form.remember}
                    onChange={handleChange}
                    className="h-4 w-4 text-royal rounded focus:ring-royal/40"
                  />
                  <span className="text-steel">{t.remember}</span>
                </label>
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={loading}
                className={`w-full py-3 rounded-sm font-bold text-lg tracking-wide transition-colors duration-300 ${
                  loading
                    ? "bg-platinum text-steel/60 cursor-not-allowed"
                    : "bg-navy text-white hover:bg-ink"
                }`}
              >
                {loading ? t.submitting : t.submit}
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
}
